import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ApiResellerProComponent} from "../../../../../../../shared/components/dialogs/api-reseller-pro/api-reseller-pro.component";
import {DbModalService} from "../../../../../../../modules/modal/modal";
import {UserSubscription} from "../../../../../../../user/user-subscription";
import {User} from "../../../../../../../user/user";
import {filter, first} from "rxjs/operators";
import {DbResponse} from "../../../../../../../shared/interceptors/db-response";
import {HostingService} from "../../../../../../../websites/website/hosting/hosting.service";

@Component({
    selector: 'db-custom-domain-initial-container',
    templateUrl: './custom-domain-initial-container.component.html',
    styleUrl: './custom-domain-initial-container.component.scss',
    standalone: false
})
export class CustomDomainInitialContainerComponent {
  domain;
  clientUrl = 'websitename.';
  @Input() user: User;
  @Input() currentSubscription: UserSubscription;
  @Input() showActions = true;
  @Input() showUpgrade = false;
  @Output() onUpgrade: EventEmitter<void> = new EventEmitter<void>();
  @Output() onAddDomain: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private _modalService: DbModalService,
    private _hostingService: HostingService,
  ) {
  }

  ngOnInit() {
    this.getHostName();
  }

  public getHostName(): void {
    this._hostingService.getUserMainDomain()
      .pipe(filter((response: DbResponse) => !!response),
        first())
      .subscribe((response: DbResponse) => {
        if (response.success) {
          this.domain = response.data.domain;
        }
        else {
          this.domain = '10web.me';
        }
      });
  }

  showAPIUpgradePopup() {
    const options = {
      overflowHidden: false,
      backdropClass: 'blurred',
    };
    options['width'] = 1240;
    const modal = this._modalService.open(ApiResellerProComponent, options);
    modal.componentInstance.currentSubscription = this.currentSubscription;
    modal.componentInstance.user = this.user;
    modal.componentInstance.fromDialog = true;
  }
}
